import _ from "lodash";
import { ONBOARDING_STATE, ROLES } from "../constants/UserSettings";


export const isUserAdmin = (user) => {
  return (_.get(user, "attributes['custom:role']", '') === ROLES.ADMIN);
}

/**
 * Given a cognito user, return whether the user is in the 
 * onbarding state.
 * @return {Boolean} true if onboarding, false if activated user
 */
export const isOnboarding = (user) => {
  const state = getUserOnboardingState(user);
  return state.includes(ONBOARDING_STATE.ONBOARDING_PREFIX) || state === "invited";
}

/**
 * Given a cognito user, get the state attribute and return it
 * Fallsback to the activated state, skipping onboarding
 * @returns {string} `custom:state` from the cognito user
 */ 
export const getUserOnboardingState = (user) => {
  return _.get(user, 'attributes.custom:state', ONBOARDING_STATE.ACTIVATED_STATE);
}
